import { LifeUserPolicies } from 'all-in-one-shared-api';
import { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils/languageUtils';
import { Row, Card, Divider, Button, Grid } from 'antd';
import ThreeItemColumn from 'components/threeItemColumn';
import styled from 'styled-components';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import './PolicyList.less';
const { useBreakpoint } = Grid;
import { useNavigate } from 'react-router-dom';
import { formatPolicy, MyPoliciesProps } from 'utils/liHome';
import { MyPolicies } from 'types/life';
import { Spinner } from 'components';

const PolicyList = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { token } = useKeycloakReady();
  const { lg } = useBreakpoint();
  const navigate = useNavigate();
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const [randoms, setRandoms] = useState(Math.random());

  const {
    shouldFetch: LifeUserPoliceShouldFetch,
    data: LifeUserPoliceData,
    error,
  } = LifeUserPolicies('LifeUserPolicies' + randoms, token ?? '', 'Y');

  // 初始加载和token变化时重新获取
  useEffect(() => {
    setStartLoading(true);
    if (token) {
      setRandoms(Math.random());
      LifeUserPoliceShouldFetch(true);
    }
  }, [LifeUserPoliceShouldFetch, token]);

  useEffect(() => {
    if (error) setStartLoading(false);
  }, [error]);
  const [lifeDataList, setLifeDataList] = useState((): MyPoliciesProps[] => {
    return [];
  });

  useEffect(() => {
    if (LifeUserPoliceData) {
      setStartLoading(false);
      setLifeDataList(formatPolicy(LifeUserPoliceData, isEnglish, LifeUserPoliceData.length) || []);
    }
  }, [LifeUserPoliceData, isEnglish]);
  const KnowMoreLinkImage = styled.img`
    margin-left: 13px;
    width: 12px;
    height: 12px;
    margin-top: 5px;
  `;
  const viewDetail = (policy: MyPolicies | undefined) => {
    navigate('/PoliciesDetail', {
      state: {
        ...policy,
      },
    });
  };
  const gotoanotherpage = (
    alertStateCode: string,
    policyNumber: string,
    companyCode: string,
    salesUnitCode?: string,
    alertPolicyUpdateStateCode?: string,
  ) => {
    if (alertStateCode) {
      if (alertStateCode === 'Issued') {
        //跳转policydetail页面
        navigate('/PoliciesCorrespondence', {
          state: {
            policyNo: policyNumber,
            companyCode: companyCode,
            salesUnitCode,
          },
        });
      } else {
        navigate('/LIPayment/PaymentDetails', {
          state: {
            policyNumber,
            companyCode,
          },
        });
      }
    } else if (alertPolicyUpdateStateCode) {
      navigate('/ChangePaymentArrangement', { state: { policyNo: policyNumber } });
    }
  };
  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      {startLoading && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      )}
      <Row gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} justify={lg ? 'start' : 'center'} wrap>
        {lifeDataList?.map((policy, index) => {
          return (
            <ThreeItemColumn key={index}>
              <Card className="policy-card">
                <div className="top-desc" onClick={() => viewDetail(LifeUserPoliceData?.[index])}>
                  <img src={policy.productCategoryUrl} alt="" className="left-icon" />
                  <div className="center-content">
                    <div
                      style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                      <p className="tagging font-setting500 letter-space4">{policy.productCategoryTitle}</p>
                      <KnowMoreLinkImage src={ChevronRight} alt="know-more-arrow" className="more" />
                    </div>
                    <h3
                      style={{
                        fontSize: '33px',
                        fontWeight: 400,
                        marginBottom: 0,
                        wordWrap: 'break-word',
                        lineHeight: '40px',
                      }}
                    >
                      {policy.productName}
                    </h3>
                    <span
                      className={`status font-setting700 font-size12 letter-space4 ${
                        policy.colour == 'GREEN' ? 'success' : policy.colour == 'RED' ? 'failB' : 'over'
                      }`}
                    >
                      {policy.policyStatus}
                    </span>
                    {!!policy.alertState && (
                      <div
                        className="show-status font-setting500 font-size17"
                        style={{
                          backgroundColor: `${policy.alertStateCode == 'Issued' ? '#F2FBE9' : ' #FDEEEC'}`,
                          color: `${policy.alertStateCode == 'Issued' ? '#549736' : '#E9573D'}`,
                        }}
                      >
                        {policy.alertState}
                      </div>
                    )}
                    {!!policy.alertPolicyUpdateStateCode && (
                      <div
                        className="show-status font-setting500 font-size17"
                        style={{
                          backgroundColor: '#FDEEEC',
                          color: '#E9573D',
                        }}
                      >
                        {policy.alertPolicyUpdateStateName}
                      </div>
                    )}
                    <p className="tagging tagging1 font-size17">
                      <span className="tag-content font-size17">{t('life.home.pnumber')}:</span>
                      {policy.policyNumber}
                    </p>
                    <p className="tagging font-size17">
                      <span className="tag-content font-size17">{t('life.home.insured')}:</span>
                      {policy.insuredName}
                    </p>
                    {policy.premiumDueDate && (
                      <p className="tagging font-size17">
                        <span className="tag-content font-size17">{t('life.home.pddate')}:</span>
                        {policy.premiumDueDate == policy.premCessationDate
                          ? t('life.home.application')
                          : policy.premiumDueDate}
                      </p>
                    )}
                  </div>
                </div>
                {!!policy.alertStateCode && policy.salesUnitCode != 'ZAL' && (
                  <>
                    <Divider />
                    <div className="bottom-button font-size17 font-setting500">
                      <Button
                        type="primary"
                        block
                        size="large"
                        color="#C21B17"
                        onClick={() => {
                          gotoanotherpage(
                            policy.alertStateCode,
                            policy.policyNumber,
                            policy.companyCode,
                            policy.salesUnitCode,
                          );
                        }}
                      >
                        {policy.alertStateCode == 'Issued' ? t('life.home.policyB') : t('life.home.policyA')}
                      </Button>
                    </div>
                  </>
                )}
                {!policy.alertStateCode && !!policy.alertPolicyUpdateStateCode && policy.salesUnitCode != 'ZAL' && (
                  <>
                    <Divider />
                    <div className="bottom-button font-size17 font-setting500">
                      <Button
                        type="primary"
                        block
                        size="large"
                        color="#C21B17"
                        onClick={() => {
                          gotoanotherpage(
                            policy.alertStateCode,
                            policy.policyNumber,
                            policy.companyCode,
                            policy.salesUnitCode,
                            policy.alertPolicyUpdateStateCode,
                          );
                        }}
                      >
                        {t('life.home.setupnow')}
                      </Button>
                    </div>
                  </>
                )}
              </Card>
            </ThreeItemColumn>
          );
        })}
      </Row>
    </div>
  );
};
export default PolicyList;
